import Vue from "vue";
const state = Vue.observable({
  category: "",
  categoryOption: [],
  product: "",
  productOption: [],
  productAll: [],
  print_tx: "",
  ticket_no: "",
  company_na: "",
  subcompany_na: "",
  client_cd: "",
  tableData: {
    data: []
  },
  modalData: [],
  error_msg: "",
  showPage: false,
  showDialog: false,
  modalData: [],
  blinkFg: false,
  test: ""
});

export const mutations = Vue.observable({
  setTable(result){
    // if (response.responseData.return != 0) {
    //   state.recordCount = response.responseData.recordCount;
    //   state.pageCount = response.responseData.pageCount;
    //   state.error_msg = response.responseData.message;
    //   return;
    // }
    // state.tableData.data = this.getAsteriaArray(
    //   response.responseData,
    //   "data"
    // );
    // state.tableData.data.jpeg_image
    // state.tableData.data.forEach(element => {
    //   let src = 'data:image/jpeg;base64,' + element.jpeg_image;
    //   element.jpeg_image = src;
    // })
    // state.currentPage = response.responseData.page;
    // state.recordCount = response.responseData.recordCount;
    // state.pageCount = response.responseData.pageCount;
    // state.hidden_param = response.responseData.hidden_param;
    // state.showPage = true;
    if (result[0].page == "0") {
      state.error_msg = result[0].error_msg;
      state.tableData.data = [];
      state.tableData.recordCount = result[0].recordCount;
      state.tableData.pageCount = result[0].pageCount;
    } else {
      state.tableData.data = result[0];
      state.tableData.currentPage = +result[1];
      state.tableData.recordCount = +result[2];
      state.tableData.pageCount = +result[3]; //total page
      state.tableData.hidden_param = result[4];

      state.tableData.data.forEach(element => {
        for(let i=0; i< state.categoryOption.length; i++){
          if(state.categoryOption[i].code == element.category_cd){
            element.category_na = state.categoryOption[i].text;
          }
        }

        let itemCode = element.cdcredept_di+ '-'+ element.part_cd;
        for(let i=0; i< state.productOption.length; i++){
          if(state.productOption[i].value == itemCode){
            element.product_na = state.productOption[i].text;
          }
        }
      })

      state.tableData.data.forEach(element => {
        element.specification_no =
        element.specification_no.includes("OP")?
        element.specification_no.replace("OP", "") : element.specification_no
      })

      /*イメージ表示*/
    //   const  base64toBlob = (base64Data, contentType) => {
    //     contentType = contentType || '';
    //     var sliceSize = 1024;
    //     var byteCharacters = atob(base64Data);
    //     var bytesLength = byteCharacters.length;
    //     var slicesCount = Math.ceil(bytesLength / sliceSize);
    //     var byteArrays = new Array(slicesCount);
    
    //     for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    //         var begin = sliceIndex * sliceSize;
    //         var end = Math.min(begin + sliceSize, bytesLength);
    
    //         var bytes = new Array(end - begin);
    //         for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
    //             bytes[i] = byteCharacters[offset].charCodeAt(0);
    //         }
    //         byteArrays[sliceIndex] = new Uint8Array(bytes);
    //     }
    //     return new Blob(byteArrays, { type: contentType });
    // }

      // state.tableData.data.forEach(element => {
      //   //if(element.jpeg_image != null){
      //     element.src = element.src.substring(1);
      //     // const blob = base64toBlob(element.src, 'image/jpeg');
      //     // const blobUrl = URL.createObjectURL(blob);
      //     // element.src = blobUrl;
      //   //}


      //   var byteStr = atob(element.src.replace('\r\n', '').split(',')[1])
      //   for (var i = 0, l = byteStr.length, content = new Uint8Array(l); l > i; i++) {
      //     content[i] = byteStr.charCodeAt(i);
      //   }
      //   const contentType = 'image/jpeg';
      //   const blob = new Blob(content, {type: contentType});
      //   const blobUrl = URL.createObjectURL(blob);
      //   element.src = blobUrl;
      // })


      /*イメージ表示*/

      state.showPage = true;
    }
  },
});

export const getters = Vue.observable({
  items: () => state
});

export const actions = Vue.observable({
  async tests(){
    const xSid = "Print";
    const xSno = "PrintTest";
    const apiParameters = {
      //"responseType" : "blob"
    };

    const response = await this.postAsteria(xSid, xSno, apiParameters);
    //console.log(response[1].jpeg_image);
  //   const  base64toBlob = (base64Data, contentType) => {
  //     contentType = contentType || '';
  //     var sliceSize = 1024;
  //     var byteCharacters = atob(base64Data);
  //     var bytesLength = byteCharacters.length;
  //     var slicesCount = Math.ceil(bytesLength / sliceSize);
  //     var byteArrays = new Array(slicesCount);
  
  //     for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
  //         var begin = sliceIndex * sliceSize;
  //         var end = Math.min(begin + sliceSize, bytesLength);
  
  //         var bytes = new Array(end - begin);
  //         for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
  //             bytes[i] = byteCharacters[offset].charCodeAt(0);
  //         }
  //         byteArrays[sliceIndex] = new Uint8Array(bytes);
  //     }
  //     return new Blob(byteArrays, { type: contentType });
  // }
    // const b64toBlob = (b64Data, contentType='', sliceSize=512) => {
    //   const byteCharacters = atob(b64Data);
    //   const byteArrays = [];
    
    //   for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    //     const slice = byteCharacters.slice(offset, offset + sliceSize);
    
    //     const byteNumbers = new Array(slice.length);
    //     for (let i = 0; i < slice.length; i++) {
    //       byteNumbers[i] = slice.charCodeAt(i);
    //     }
    
    //     const byteArray = new Uint8Array(byteNumbers);
    //     byteArrays.push(byteArray);
    //   }
    
    //   const blob = new Blob(byteArrays, {type: contentType});
    //   return blob;
    // }



  //   var byteStr = atob(response[1].jpeg_image.replace('\r\n', '').split(',')[1])
  //   for (var i = 0, l = byteStr.length, content = new Uint8Array(l); l > i; i++) {
  //     content[i] = byteStr.charCodeAt(i);
  // }
  //   const contentType = 'image/jpeg';
  //   const blob = new Blob(content, {type: contentType});
  //   const blobUrl = URL.createObjectURL(blob);
  //   this.items.test = blobUrl;
   this.items.test = response[0].jpeg_image;
    //console.log(this.items.test)
  },
  async fetchCategory(){
    const xSid = "Print";
    const xSno = "printCategory";
    const apiParameters = {};
    const result = await this.postAsteria(xSid, xSno, apiParameters);
    this.items.categoryOption = result;
  },
  async fetchProduct(){
    const xSid = "Print";
    const xSno = "printItem";
    const apiParameters = {};
    const result = await this.postAsteria(xSid, xSno, apiParameters);
    this.items.productOption = result;
    this.items.productAll = result;
  },
  async searchPrint (page){
    let categoryCd = "";
    let productCd = ["", ""];
    let arrNum = 0;
    //カテゴリー、製品からパラメータ取得
    if(this.items.product != "" && this.items.product != null){
      for(let i=0; i<this.items.productOption.length; i++){
        if(this.items.product == this.items.productOption[i].value){
          arrNum = i;
        }
      }
      categoryCd = this.items.productOption[arrNum].code;
      productCd = this.items.productOption[arrNum].value.split("-");
    }else if(this.items.category != "" && this.items.category != null ){
      categoryCd = this.items.category;
    }else{
      categoryCd = "";
      productCd = ["", ""];
    }
    const xSid = "Print";
    const xSno = "printSearch";
    const apiParameters = {
      category_cd: categoryCd,
      cdcredept_di: productCd[0],
      part_cd: productCd[1],
      print_tx: this.items.print_tx,
      ticket_no: this.items.ticket_no,
      page: page
    };
    this.items.showPage = false;
    await this.searchPrintCommon(xSid, xSno, apiParameters);
  },
  async pagingSearch (page){
    this.items.error_msg = "";
    const xSid = "Print";
    const xSno = "printSearch";
    const apiParameters = {
      category_cd: this.items.tableData.hidden_param.categoryCd,
      cdcredept_di: this.items.tableData.hidden_param.cdcredept_di,
      part_cd: this.items.tableData.hidden_param.part_cd,
      print_tx: this.items.tableData.hidden_param.print_tx,
      ticket_no: this.items.tableData.hidden_param.ticket_no,
      page: page
    };
    await this.searchPrintCommon(xSid, xSno, apiParameters);
  },
  async searchPrintCommon (xSid, xSno, apiParameters){
    this.items.error_msg = "";
    const response = await this.postAsteria(xSid, xSno, apiParameters);
    mutations.setTable(response);
  },
  
  checkDelete: (cd) => {
    if(cd =='0') return true
    else return false
  },
  dispModal(item){
    this.items.modalData = item;
    this.items.showDialog = true;
  },
  suggest(e){
    console.log(this.items.category)
    let cd = this.items.category
    this.items.productOption = [];
    if(cd == ""){
      this.items.productOption = this.items.productAll;
      this.items.product = "";
    }else{
      this.items.productAll.forEach(element => {
        if(cd == element.code){
          this.items.productOption.push(element);
        }
      })
      this.items.product = "";
      this.items.blinkFg = true;
      setTimeout(() => {
        this.items.blinkFg = false;
      }, 1100)
    }
    
  },
  async updateDisp(item){
    const xSid = "Print";
    const xSno = "printToggle";
    const apiParameters = {
      client_cd: this.items.client_cd_origin,
      ticket_no: item.ticket_no,
      specification_no: item.specification_no,
      delete_fg: item.delete_fg
    };
    const response = await this.postAsteria(xSid, xSno, apiParameters);
    if(response[0].return =="0"){
      this.$message({
        showClose: true,
        message: response[0].msg
      });
      this.$refs.printDialog.hideModal();
      await this.pagingSearch(this.items.tableData.currentPage);
    }
  }
});